// Module
var code = `<div class="chart-container"></div>
`;
// Exports
export default code;